import {
  Button,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { TextField } from "@mui/material";
import { FaTrashAlt } from "react-icons/fa";

interface AIFunctionPropertiesFormProps {
  field: any;
}
export const AIFunctionPropertiesForm = () => {
  const { register, getValues, setValue, control } = useFormContext();
  return (
    <div>
      <div className="mb-16">
        {getValues("parameters").map((parameter: any, index: number, array: any[]) => (
          <div key={index} className="mb-8 flex flex-col gap-2">
            <div className="flex gap-4">
              <TextField
                label="Имя параметра"
                type="text"
                {...register(`parameters[${index}].name`, { required: true })}
              />
              <FormControl>
                <InputLabel>Тип</InputLabel>
                <Controller
                  name={`parameters[${index}].type`}
                  rules={{ required: true }}
                  control={control}
                  render={({ field }) => (
                    <Select label="Тип" {...field}>
                      <MenuItem value="string">Строка</MenuItem>
                      <MenuItem value="number">Число</MenuItem>
                      <MenuItem value="boolean">Логическое значение</MenuItem>
                    </Select>
                  )}
                />
              </FormControl>
              <TextField
                className="flex-1"
                label="Описание"
                type="text"
                {...register(`parameters[${index}].description`, { required: true })}
              />
              <IconButton
                onClick={() => {
                  const parameters = getValues("parameters");
                  parameters.splice(index, 1);
                  setValue("parameters", parameters);
                }}
              >
                <FaTrashAlt size={14} />
              </IconButton>
            </div>
            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    {...register(`parameters[${index}].required`)}
                    defaultChecked={getValues(`parameters[${index}].required`)}
                  />
                }
                label="Обязательное поле"
              />
            </div>
            {index != array.length - 1 && <Divider />}
          </div>
        ))}
      </div>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => {
          setValue("parameters", [
            ...getValues("parameters"),
            {
              name: "",
              description: "",
              type: "string",
            },
          ]);
        }}
      >
        Добавить свойство
      </Button>
    </div>
  );
};
